// Core v2 Availspace / FrameworkTicknesses enum values. These used to come
// from /masters/core/meta and are no longer returned.

export const AVAILSPACE = [
  '0.5 mm',
  '0.8 mm',
  '1.0 mm',
  '1.2 mm',
  '1.5 mm',
] as const

export const FRAMEWORK_THICKNESSES = [
  '0.3 mm',
  '0.4 mm',
  '0.5 mm',
  '0.6 mm',
  '0.7 mm',
  '0.8 mm',
  '0.9 mm',
  '1.0 mm',
  '1.1 mm',
  '1.2 mm',
] as const

const toSelectOptions = (values: readonly string[]) =>
  values.map((value) => ({ value, text: value }))

export const FRAMEWORK_THICKNESS_OPTIONS = toSelectOptions(
  FRAMEWORK_THICKNESSES,
)

export const AVAILSPACE_VALUES = [0.5, 0.8, 1.0, 1.2, 1.5] as const

export const AVAILSPACE_SLIDER_RANGE = AVAILSPACE_VALUES.map(
  (value, index) => ({
    value,
    step: index + 1,
  }),
)
